import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, styled, useTheme } from '@streem/ui-react';
import { scrubDataId } from '@streem/toolbox';
export const Diagnosis = ({ diagnoses, disposition, outOfScopeDiscussion, outOfScopeDiscussionReasons, refundRequest, screenShare, showScreenShare, contractorCall, showContractorCall, hvacMentioned, showHvacMentioned, refundReason, dataIdPrefix, singleColumn = false, diagnosisStyles, keyValueStyles, showOutOfScopeDiscussionYn, showRefundRequestYn, }) => {
    const theme = useTheme();
    const effectiveTitleFontSize = (diagnosisStyles?.titleFontSize ||
        theme.text.size.mediumLarge);
    const effectiveItemFontSize = (keyValueStyles?.fontSize || theme.text.size.medium);
    const Tile = singleColumn ? DiagnosisColumnTile : DiagnosisRowTile;
    return (_jsxs(DiagnosisWrapper, { children: [_jsx(HeaderWrapper, { titleFontSize: effectiveTitleFontSize, "data-testid": `${dataIdPrefix}-diagnosis-header`, children: "Diagnosis" }), _jsxs(Tile, { children: [_jsx(TileSegmentForArray, { title: "Diagnosis", values: diagnoses, fontSize: effectiveItemFontSize, dataIdPrefix: dataIdPrefix }), _jsx(TileSegmentForSingleValue, { title: "Disposition", value: disposition, fontSize: effectiveItemFontSize, dataIdPrefix: dataIdPrefix }), showOutOfScopeDiscussionYn && (_jsx(TileSegmentForSingleValue, { title: "Out of Scope Discussion", value: outOfScopeDiscussion ? 'Yes' : 'No', fontSize: effectiveItemFontSize, dataIdPrefix: dataIdPrefix })), Array.isArray(outOfScopeDiscussionReasons) && (_jsx(TileSegmentForArray, { title: "Out of Scope Discussion Reason", values: outOfScopeDiscussionReasons, fontSize: effectiveItemFontSize, dataIdPrefix: dataIdPrefix })), showScreenShare && (_jsx(TileSegmentForSingleValue, { title: "Screen Share", value: screenShare ? 'Yes' : 'No', fontSize: effectiveItemFontSize, dataIdPrefix: dataIdPrefix })), showContractorCall && (_jsx(TileSegmentForSingleValue, { title: "Contractor Call", value: contractorCall ? 'Yes' : 'No', fontSize: effectiveItemFontSize, dataIdPrefix: dataIdPrefix })), showHvacMentioned && (_jsx(TileSegmentForSingleValue, { title: "HVAC Upgrade Mentioned", value: hvacMentioned ? 'Yes' : 'No', fontSize: effectiveItemFontSize, dataIdPrefix: dataIdPrefix })), showRefundRequestYn && (_jsx(TileSegmentForSingleValue, { title: "Refund Request", value: refundRequest ? 'Yes' : 'No', fontSize: effectiveItemFontSize, dataIdPrefix: dataIdPrefix })), refundReason && (_jsx(TileSegmentForSingleValue, { title: "Refund Reason", value: refundReason, fontSize: effectiveItemFontSize, dataIdPrefix: dataIdPrefix }))] })] }));
};
const TileSegmentForArray = ({ title, values, fontSize, dataIdPrefix, }) => {
    const listItems = values.map((v, idx) => {
        return (_jsx("li", { "data-testid": scrubDataId(`${dataIdPrefix}-${title}-item-${idx}`), children: v }, v));
    });
    return (_jsx(TileSegment, { title: title, fontSize: fontSize, dataIdPrefix: dataIdPrefix, children: _jsx(TileSegmentOL, { fontSize: fontSize, "data-testid": scrubDataId(`${dataIdPrefix}-items-${title}`), children: listItems }) }));
};
const TileSegmentForSingleValue = ({ title, value, fontSize, dataIdPrefix, }) => {
    return (_jsx(TileSegment, { title: title, fontSize: fontSize, dataIdPrefix: dataIdPrefix, children: _jsx(TileSegmentValue, { fontSize: fontSize, "data-testid": scrubDataId(`${dataIdPrefix}-value-${title}`), children: value }) }));
};
const TileSegment = ({ children, title, fontSize, dataIdPrefix, }) => {
    return (_jsxs(TileSegmentWrapper, { children: [_jsx(TileSegmentTitle, { fontSize: fontSize, "data-testid": scrubDataId(`${dataIdPrefix}-diagnosis-key-${title}`), children: title }), children] }));
};
const TileSegmentTitle = styled.div(props => ({
    marginBottom: '0.5rem',
    fontSize: props.fontSize,
    lineHeight: props.theme.text.lineHeight.medium,
    fontFamily: props.theme.text.headingFontFamily,
    fontWeight: 500,
}));
const TileSegmentWrapper = styled.div({
    minWidth: '30%',
});
const DiagnosisWrapper = styled.section({
    display: 'inline-block',
    padding: '.75rem 0 0.4rem 0',
    width: '100%',
});
const HeaderWrapper = styled.div(props => ({
    marginBottom: '.75rem',
    fontFamily: props.theme.text.headingFontFamily,
    fontWeight: 500,
    lineHeight: props.theme.text.lineHeight.medium,
    fontSize: props.titleFontSize,
}));
const DiagnosisRowTile = styled(Grid)(({ theme }) => ({
    backgroundColor: theme.colors.grey01A50,
    gridTemplateColumns: 'repeat(3, 1fr)',
    padding: '0.5rem 1rem',
    gap: '1rem',
}));
const DiagnosisColumnTile = styled(Grid)(({ theme }) => ({
    backgroundColor: theme.colors.grey01A50,
    gridTemplateColumns: '1fr',
    padding: '0.5rem 1rem',
    gap: '1rem',
}));
const TileSegmentOL = styled.ol(props => ({
    margin: 0,
    padding: '0 0 0 1rem',
    fontFamily: props.theme.text.bodyFontFamily,
    fontSize: props.fontSize,
    lineHeight: props.theme.text.lineHeight.medium,
    listStyleType: 'decimal',
    fontWeight: 400,
}));
const TileSegmentValue = styled.span(props => ({
    fontFamily: props.theme.text.bodyFontFamily,
    fontSize: props.fontSize,
    lineHeight: props.theme.text.lineHeight.medium,
    fontWeight: 400,
}));
//# sourceMappingURL=diagnosis.js.map